import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/header.svg'
import _imports_1 from '@/assets/icons/twitter_white.svg'
import _imports_2 from '@/assets/icons/youtube.svg'
import _imports_3 from '@/assets/icons/nikodou.png'
import _imports_4 from '@/assets/logo/footer.svg'


const _withScopeId = n => (_pushScopeId("data-v-6a72f571"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "v-line v-line-text q-ma-none absolute-left" }
const _hoisted_2 = { class: "tab" }
const _hoisted_3 = { class: "row q-pl-md" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_5 = { class: "row justify-between" }
const _hoisted_6 = { class: "gt-sm" }
const _hoisted_7 = { style: {"margin-top":"auto"} }
const _hoisted_8 = { class: "tab" }
const _hoisted_9 = { class: "q-pr-md row desktop-only q-pl-md" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-pr-md q-pt-lg" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "gt-sm q-pa-none footnotesize" }, "このサイトのコンテンツは一部を除き『斜向』が著作権を有しています"),
  /*#__PURE__*/_createElementVNode("p", { class: "gt-sm q-pa-none footnotesize" }, "これらの無断での転載、不正利用を断じて禁じます"),
  /*#__PURE__*/_createElementVNode("p", { class: "q-pa-none footnotesize" }, "© 斜向 All Rights Reserved.")
], -1))

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

var tab = ref('')
var menuOpen = ref(false)

const menuItem = [
  {
    to: "/#about",
    label: "About"
  },
  {
    to: "/works",
    label: "Works"
  },
  {
    to: "/contact",
    label: "Contact"
  },
]


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator, {
        vertical: "",
        color: _ctx.$route.path === '/' ? 'white' : 'black',
        size: "1.5pt",
        class: "absolute-left v-line",
        style: {"top":"50px"}
      }, null, 8, ["color"]),
      _withDirectives(_createElementVNode("p", _hoisted_1, " Scroll down → ", 512), [
        [_vShow, _ctx.$route.path === '/' && _ctx.$q.platform.is.desktop]
      ]),
      _withDirectives(_createVNode(_component_q_separator, {
        vertical: "",
        color: "black",
        size: "1.5pt",
        class: "absolute-left v-line",
        style: {"top":"100vh"}
      }, null, 512), [
        [_vShow, _ctx.$q.platform.is.desktop]
      ]),
      _withDirectives(_createVNode(_component_q_separator, {
        vertical: "",
        color: "black",
        size: "1.5pt",
        class: "absolute-left v-line",
        style: {"top":"calc(30vh + 50px)"}
      }, null, 512), [
        [_vShow, _ctx.$q.platform.is.mobile]
      ]),
      _createVNode(_component_q_header, {
        reveal: "",
        class: "bg-black"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_img, {
                    src: _imports_0,
                    width: "200px"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_space),
              _createVNode(_component_q_tabs, {
                modelValue: _unref(tab),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tab) ? (tab).value = $event : tab = $event)),
                shrink: "",
                class: "gt-sm text-white q-py-sm"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItem, (item, index) => {
                    return _createVNode(_component_q_route_tab, {
                      key: index,
                      to: item.to,
                      name: 'tab'+index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "name"])
                  }), 64)),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_q_btn, {
                      square: "",
                      outline: "",
                      href: "https://twitter.com/hsmkai",
                      target: "_blank",
                      class: "q-mx-xs snsBtn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_avatar, {
                          square: "",
                          size: "25px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, { src: _imports_1 })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      square: "",
                      outline: "",
                      href: "https://www.youtube.com/channel/UCRb01Kwyx9638bL4AtaYYfA",
                      target: "_blank",
                      class: "q-mx-xs snsBtn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_avatar, {
                          square: "",
                          size: "25px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, { src: _imports_2 })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      square: "",
                      outline: "",
                      href: "https://www.nicovideo.jp/user/91326809/video",
                      target: "_blank",
                      class: "q-mx-xs snsBtn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_avatar, { square: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, { src: _imports_3 })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "menu",
                size: "20px",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(menuOpen) //@ts-ignore
 ? menuOpen.value = !_unref(menuOpen) : menuOpen = !_unref(menuOpen))),
                class: "lt-md text-white"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator, {
            color: "black",
            size: "1.5pt"
          })
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_q_drawer, {
        modelValue: _unref(menuOpen),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(menuOpen) ? (menuOpen).value = $event : menuOpen = $event)),
        width: 200,
        overlay: "",
        bordered: "",
        class: "bg-gray-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItem, (item) => {
                return _createVNode(_component_q_item, {
                  key: item,
                  clickable: "",
                  to: item.to
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_footer, { class: "bg-black" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_q_avatar, {
                square: "",
                class: "q-pa-xl footer-logo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_img, { src: _imports_4 })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_q_img, {
              src: _imports_4,
              class: "lt-sm footer-logo"
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_tabs, {
                modelValue: _unref(tab),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(tab) ? (tab).value = $event : tab = $event)),
                shrink: "",
                align: "right",
                style: {"width":"70vw"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItem, (item, index) => {
                    return _createVNode(_component_q_route_tab, {
                      key: index,
                      to: item.to,
                      name: 'tab'+index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "name"])
                  }), 64)),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_q_btn, {
                      square: "",
                      outline: "",
                      href: "https://twitter.com/hsmkai",
                      target: "_blank",
                      class: "q-mx-xs snsBtn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_avatar, {
                          square: "",
                          size: "25px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, { src: _imports_1 })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      square: "",
                      outline: "",
                      href: "https://www.youtube.com/channel/UCRb01Kwyx9638bL4AtaYYfA",
                      target: "_blank",
                      class: "q-mx-xs snsBtn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_avatar, {
                          square: "",
                          size: "25px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, { src: _imports_2 })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      square: "",
                      outline: "",
                      href: "https://www.nicovideo.jp/user/91326809/video",
                      target: "_blank",
                      class: "q-mx-xs snsBtn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_avatar, {
                          square: "",
                          size: "40px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, { src: _imports_3 })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_10
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})